import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ApprovalsSvg = function ApprovalsSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F6A35",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.75 12.417a.59.59 0 0 1 .834 0l2.5 2.5a.59.59 0 1 1-.834.833l-2.5-2.5a.59.59 0 0 1 0-.833m12.5-3.334a.59.59 0 0 1 0 .834L12 16.167 9.084 13.25a.59.59 0 1 1 .833-.833L12 14.5l5.417-5.417a.59.59 0 0 1 .833 0m-3.333.834-2.5 2.5a.59.59 0 1 1-.833-.834l2.5-2.5a.59.59 0 1 1 .833.834",
    clipRule: "evenodd"
  }));
};
export var Approvals = function Approvals(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ApprovalsSvg
  }));
};